import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    questions: {
        data: [],
        loading: false,
        error: null,
        page: 1,
        limit: 1,
        total: 0,
        totalPages: 1,
        userProgresses: [],
        
    },
    newAssessmentRequest: {
        loading: false,
        error: null,
    },
    loading: false,
    error: null,
    userResult: null
};

const assessmentSlice = createSlice({
    name: 'assessment',
    initialState,
    reducers: {
        fetchQuestionsStart: (state, action) => {
            state.questions.loading = true;
            state.questions.error = null;
            state.questions.data = [];
        },
        fetchQuestionsSuccess: (state, action) => {
            state.questions = { ...action.payload, loading: false };
        },
        fetchQuestionsFail: (state, action) => {
            state.questions.loading = false;
            state.questions.error = action.payload;
        },
        submitAnswerStart: (state) => {
            state.loading = true;
        },
        submitAnswerSuccess: (state, action) => {
            const { questionID, response } = action.payload.userAnswer;
            const progress = action.payload.progress;
            state.loading = false;

            state.questions.data = state.questions.data.map((question) =>
                question._id === questionID
                    ? { ...question, alreadyAnswered: true, userResponse: response }
                    : question
            );

            const index = state.questions.userProgresses.findIndex(
                (p) => p._id === progress._id
            );

            if (index !== -1) {
                state.questions.userProgresses[index] = progress;
            } else {
                state.questions.userProgresses.push(progress);
            }
        },
        submitAnswerFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        finalizeUserResultStart: (state, action) => {
            state.loading = true;
        },
        finalizeUserResultSuccess: (state, action) => {
            const { userProgresses, userResult } = action.payload
            state.questions.userProgresses = userProgresses;
            state.userResult = userResult;
            state.loading = false;
        },
        finalizeUserResultFail: (state, action) => {
            state.loading = false;
        },
        fetchUserResultStart: (state, action) => {
            state.loading = true;
        },
        fetchUserResultSuccess: (state, action) => {
            state.userResult = action.payload;
            state.loading = false;
        },
        fetchUserResultFail: (state, action) => {
            state.loading = false;
        },
        createNewAssessmentRequestStart: (state, action) => {
            state.newAssessmentRequest.loading = true;
        },
        createNewAssessmentRequestSuccess: (state, action) => {
            state.newAssessmentRequest = { ...action.payload, loading: false };
        },
        createNewAssessmentRequestFail: (state, action) => {
            state.questions.loading = false;
            state.questions.error = action.payload;
        },
    },
});

export const {
    fetchQuestionsStart,
    fetchQuestionsSuccess,
    fetchQuestionsFail,
    submitAnswerStart,
    submitAnswerSuccess,
    submitAnswerFail,
    finalizeUserResultStart,
    finalizeUserResultSuccess,
    finalizeUserResultFail,
    fetchUserResultStart,
    fetchUserResultSuccess,
    fetchUserResultFail,
    createNewAssessmentRequestStart,
    createNewAssessmentRequestSuccess,
    createNewAssessmentRequestFail
} = assessmentSlice.actions;

export default assessmentSlice.reducer;